export default function BookingLimitedModal(
    $scope,
    $element,
    period,
    lane,
    close
) {
    $scope.period = period;

    // TO DO ::: API LimitedBooking azure issue
    $scope.message = lane.LimitedBooking.Message;
    $scope.link = lane.LimitedBooking.Link;
    $scope.linkText = lane.LimitedBooking.LinkText;

    $scope.modalClose = function (period) {
        $element.modal("hide");

        close(period, 500); // close, but give 500ms for bootstrap to animate
    };
}
